import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';

import * as PublicWifiActions from './../actions/public-wifi.actions';
import { IEntity } from '@proximus/entity-manager';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { TechnicalError } from '@dch/products-business-logic';
import { PublicWifiService } from '../../services/public-wifi.service';

@Injectable()
export class PublicWifiEffects {
  @Effect()
  products$: Observable<Action> = this.actions$.pipe(
    ofType(PublicWifiActions.GET_PUBLIC_WIFI_PRODUCTS),
    mergeMap((action: PublicWifiActions.GetPublicWifiProducts) =>
      this.publicWifiService.getProducts().pipe(
        map(
          (entity: any) =>
            new PublicWifiActions.GetPublicWifiProductsSuccess(entity.headers),
        ),
        catchError((error: IEntity<TechnicalError>) => {
          if (error.status === 304) {
            return of(
              new PublicWifiActions.GetPublicWifiProductsSuccess(
                (error as any).headers,
              ),
            );
          }
          return of(
            new PublicWifiActions.GetPublicWifiProductsFailed(
              error.errorData as TechnicalError,
            ),
          );
        }),
      ),
    ),
  );

  @Effect()
  accounts$: Observable<Action> = this.actions$.pipe(
    ofType(PublicWifiActions.GET_PUBLIC_WIFI_ACCOUNTS),
    mergeMap((action: PublicWifiActions.GetPublicWifiAccounts) =>
      this.publicWifiService.getAccounts(action.payload).pipe(
        map(
          (entity: IEntity<any>) =>
            new PublicWifiActions.GetPublicWifiAccountsSuccess(entity.value),
        ),
        catchError((error: IEntity<TechnicalError>) =>
          of(
            new PublicWifiActions.GetPublicWifiAccountsFailed(
              error.errorData as TechnicalError,
            ),
          ),
        ),
      ),
    ),
  );

  @Effect()
  createAlias$: Observable<Action> = this.actions$.pipe(
    ofType(PublicWifiActions.CREATE_PUBLIC_WIFI_LOGIN_ALIAS),
    mergeMap((action: PublicWifiActions.CreatePublicWifiLoginAlias) =>
      this.publicWifiService.createAlias(action.payload).pipe(
        map(
          (entity: IEntity<any>) =>
            new PublicWifiActions.CreatePublicWifiLoginAliasSuccess(
              entity.value,
            ),
        ),
        catchError((error: IEntity<TechnicalError>) =>
          of(
            new PublicWifiActions.CreatePublicWifiLoginAliasFailed(
              error.errorData as TechnicalError,
            ),
          ),
        ),
      ),
    ),
  );

  @Effect()
  updateAlias$: Observable<Action> = this.actions$.pipe(
    ofType(PublicWifiActions.UPDATE_PUBLIC_WIFI_LOGIN_ALIAS),
    mergeMap((action: PublicWifiActions.UpdatePublicWifiLoginAlias) =>
      this.publicWifiService.updateAlias(action.payload).pipe(
        map(
          (entity: IEntity<any>) =>
            new PublicWifiActions.UpdatePublicWifiLoginAliasSuccess(
              entity.value,
            ),
        ),
        catchError((error: IEntity<TechnicalError>) =>
          of(
            new PublicWifiActions.UpdatePublicWifiLoginAliasFailed(
              error.errorData as TechnicalError,
            ),
          ),
        ),
      ),
    ),
  );

  @Effect()
  updatePassword$: Observable<Action> = this.actions$.pipe(
    ofType(PublicWifiActions.UPDATE_PUBLIC_WIFI_PASSWORD),
    mergeMap((action: PublicWifiActions.UpdatePublicWifiPassword) =>
      this.publicWifiService.updatePassword(action.payload).pipe(
        map(
          (entity: IEntity<any>) =>
            new PublicWifiActions.UpdatePublicWifiPasswordSuccess(entity.value),
        ),
        catchError((error: IEntity<TechnicalError>) =>
          of(
            new PublicWifiActions.UpdatePublicWifiPasswordFailed(
              error.errorData as TechnicalError,
            ),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private publicWifiService: PublicWifiService,
  ) {}
}
